export const Regions = {
  SAO_PAULO: 4,
  TODAS_REGIOES: 0,
  UBERLANDIA: 3,
  NOVA_UBERLANDIA: 5,
};
